<template>
    <div>
        <page-title>{{ title }}</page-title>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-allowances-table :company-id="companyId">
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.COMPANY_ALLOWANCE_CREATE"
                    tabbed
                ></create-button>
            </template>
        </company-allowances-table>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import SelectApiClienType from '@/api/SelectApiClientType'
import TitleMixinGenerator from '@/components/mixins/page-title/TitleMixinGenerator'
import AuthMixin from '@/components/mixins/AuthMixin'
import CreateButton from '@/components/form/Actions/CreateButton'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import CompanyAllowancesTable from '@/components/pages/companyAllowances/Table'

export default {
    components: {
        CreateButton,
        CompanyRouteTabs,
        CompanyAllowancesTable,
    },
    mixins: [
        TitleMixinGenerator(SelectApiClienType.COMPANY, 'companyId'),
        AuthMixin,
    ],
    props: {
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            routeType,
        }
    },
}
</script>
